<script setup>

import { defineProps } from 'vue';


const props = defineProps({
    options: Object,
});

// console.log(props.options.inputOptions);


if (props.options.inputOptions.length === 1) {
    const selectedValue = JSON.parse(JSON.stringify(props.options.inputOptions[0].optionValue));
    if (props.options.inputType === 'radio') {
        props.options.inputValue = selectedValue;
    } else if (props.options.inputType === 'checkbox') {
        props.options.inputValue = [selectedValue];
    }
}

const isChoosed = (optionValue) => {
    if (props.options.inputType === 'checkbox') {
        return props.options.inputValue.includes(optionValue)
    } else if (props.options.inputType === 'radio') {
        return optionValue === props.options.inputValue
    }
    return false;
}

const checkValidNumber = (number) => {
    const regex = /^[0-9]*(\.[0-9]{1,2})?$/;
    return !regex.test(number);
}

/*
options = {
    inputValue: '',
    inputName: 'bank',            //群組
    inputType: 'radio',           //radio/checkbox
    inputOptions:
    [
        {
            title: 'XWS5 富邦人壽新平準終身壽險',
            subTitle: '1068302189-00',
            list: [
                { key: '幣別', value: '新臺幣', },
                { key: '要保人', value: '林大富', },
                { key: '被保險人', value: '林小邦', },
            ],
            optionValue: '1068302189-00',
            textInputList: [{
                name: '欲借款金額',
                value: '',
                placeholder: '請輸入借款金額',
            }],
        },
    ],
};
*/


// const inputChange = (e) => {
//     // props.setInputValue(e.target.value);
//     props.options.inputValue = e.target.value
// }

</script>

<template>

    <!-- <div class="list-box box--shadow mb-3 bg-white rounded-md overflow-hidden border"
        :class="(inputOption.optionValue === options.inputValue) ? 'border-[#0093C1]' : ' border-white'"
        v-for="inputOption in options.inputOptions"> -->
    <div class="list-box box--shadow mb-3 bg-white rounded-md overflow-hidden border"
        :class="isChoosed(inputOption.optionValue) ? 'border-[#0093C1]' : ' border-white'"
        v-for="inputOption in options.inputOptions">

        <label>
            <div class="p-4 flex" :class="{ 'list-box__title--blue': inputOption.list }"
                v-if="inputOption.title || inputOption.subTitle || inputOption.bottomSubTitle">

                <div class="pr-3">
                    <input class="w-[20px] h-[20px] align-text-bottom" :type="options.inputType"
                        v-model="options.inputValue" :value="inputOption.optionValue" :name="options.inputName" />
                </div>
                <div>
                    <div class="pb-2 pr-2 text-sm" v-if="inputOption.subTitle">
                        {{ inputOption.subTitle }}
                    </div>
                    <h4 v-if="inputOption.title" class="font-bold">{{ inputOption.title }}</h4>
                    <div class="pt-2 pr-2 text-sm" v-if="inputOption.bottomSubTitle">
                        {{ inputOption.bottomSubTitle }}
                    </div>
                </div>

            </div>

            <div class="px-4 pb-4" v-if="inputOption.list">
                <ul>
                    <li class="w-full flex justify-between pt-4" v-for="(item, i) in inputOption.list">
                        <div>{{ item.key }}</div>
                        <div class="font-bold" v-html="item.value"></div>
                    </li>
                </ul>
            </div>

        </label>

        <template v-if="inputOption.textInputList?.length">
            <div class="px-4"
                v-show="(options.inputType === 'checkbox') ? (options.inputValue).includes(inputOption.optionValue) : options.inputValue === inputOption.optionValue">
                <hr>
                <ul class="py-4">
                    <li v-for="item in inputOption.textInputList">
                        <div class="font-bold pb-2">{{ item.name }}</div>
                        <input
                            :class="{ 'border-[#EB4751]': item.value !== '' && (item.value > item.max || item.value < item.min || checkValidNumber(item.value)) }"
                            :type="item.type" v-model="item.value" :placeholder="item.placeholder"
                            :inputmode="item.inputmode" />
                        <div class="text-[#EB4751] text-sm">
                            <div v-show="item.value !== '' && item.value > item.max">{{ item.maxErrorText }}</div>
                            <div v-show="item.value !== '' && item.value < item.min">{{ item.minErrorText }}</div>
                            <div v-show="checkValidNumber(item.value)">請輸入有效的數字</div>
                        </div>
                    </li>
                </ul>
            </div>
        </template>


        <!-- 
        *          name: '欲借款金額',
        *          value: '',
        *          placeholder: '請輸入借款金額',
        -->

    </div>

</template>

<style scoped>
.list-box__title--blue {
    background: linear-gradient(81.29deg, #F0F9FF 2.99%, #E9FFFE 107.35%);
}

.box--shadow {
    box-shadow: 0px 4px 16px 0px #0C0E1F0F;
}
</style>
